<template>
  <div class="row w-100 token">
    <div class="col-12 px-lg-5">
      <img class="img-fluid" src="/assets/images/token.webp" alt="Token" />
      <p class="mt-5">
        $RAID & $SKAL are tokens with ERC-20 standard existing on Avalanche blockchain
        network, possessing utility functions and attributed governance ability in the
        ValhallaVerse.
      </p>
      <p>
        For Tokenomics and further details, please
        <a
          href="https://valhallaverse.gitbook.io/whitepaper/economy/tokenomics"
          target="_blank"
          >click here</a
        >.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Token",
};
</script>

<style lang="scss" scoped>
.token {
  * {
    text-align: center;
  }
  img {
    max-width: 100%;
  }
}
</style>
